import Cookies from "js-cookie"
import ReactNativeTokenController from "./react_native_token_base_controller"

export default class extends ReactNativeTokenController {
  connect() {
    const key = "initial_react_native_token_upserted"
    const daysToExpiration = 60
    if (window.ReactNativeWebView && !Cookies.get(key)) {
      this.requestReactNativeToken()
      Cookies.set(key, true, { expires: daysToExpiration })
    }
  }
}
